import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { FuturesStateType, StoreFutureExpiries } from "../reducer/futures.reducer"
import { RootState } from "../store"
import { futureTradeDataType } from "../pages/typings/options.typings"

const state = (state: RootState) => state

export const selectFuturesExpiryData = createDraftSafeSelector(state, (state: RootState) => state.futuresStore.expiries as FuturesStateType['expiries'])

const defaultFutureExpiries = {current: [], past: []}
export const selectUnderlyingFutureExpiries = (key: string) => createDraftSafeSelector(state, (state: RootState) => {
    return (state.futuresStore.expiries[key] || defaultFutureExpiries) as StoreFutureExpiries
})

export const selectFutureColumnValue = (underlyingKey: string, key: string, column: string, subColumn: string) => createDraftSafeSelector(state, (state: RootState) => {
    const underlyingFuturesData = (state.futuresStore.futuresData[underlyingKey] || undefined) as futureTradeDataType[] | undefined
    if(!underlyingFuturesData) return undefined
    const futureData = underlyingFuturesData?.find(d => d.key === key)
    if(!futureData) return undefined
    switch(column){
        case 'ltp': {return futureData.ltp}
        case 'volume': {return futureData.volume}
        case 'impliedVolatility': {return futureData.impliedVolatility}
        case 'openInterest': {return futureData.openInterest}
        case 'oiChange|outlook': {
            if(subColumn === 'oiChange'){
                return futureData.oiChange
            }else if(subColumn === 'outlook'){
                return undefined
            }
            return undefined
        }
        case 'bid': {
            return futureData.bid
        }
        case 'ask': {
            return futureData.ask
        }
        default: {return undefined}

    }
})

export const selectFutureData = (underlyingKey: string, key: string) => createDraftSafeSelector(state, (state: RootState) => {
    const underlyingFuturesData = (state.futuresStore.futuresData[underlyingKey] || undefined) as futureTradeDataType[] | undefined
    if(!underlyingFuturesData) return {}
    const futureData = underlyingFuturesData?.find(d => d.key === key)
    return (futureData || {}) as any
})

export const selectFuturesMetaData = (underlyingKey: string) => createDraftSafeSelector(state, (state: RootState) => {
    const underlyingFuturesData = (state.futuresStore.futuresData[underlyingKey] || undefined) as futureTradeDataType[] | undefined
    if(!underlyingFuturesData) return {maxOi: 0, maxOiChange: 0}
    const maxOi = Math.max(...(underlyingFuturesData??[]).map(d => d.openInterest))
    const maxOiChange = Math.max(...(underlyingFuturesData??[]).map(d => Math.abs(d.oiChange)))
    const maxPricePercentChange = Math.max(...(underlyingFuturesData??[]).map(d => Math.abs(d.lptChangePercent)))
    return {
        maxOi, maxOiChange, maxPricePercentChange
    }
})

export const selectUnderlyingFuturesTradeData = (key: string) => createDraftSafeSelector(state, (state: RootState) => {
    return (state.futuresStore.futuresData[key] || undefined) as futureTradeDataType[] | undefined
})

export const selectFuturesData = createDraftSafeSelector(state, (state: RootState) => state.futuresStore.futuresData as FuturesStateType['futuresData'])